import { Component } from '@angular/core';
import { AbstractControl, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AdminapiService } from '../../shared/services/adminapi.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { UserInfo } from 'src/app/store/actions/user.action';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/store/app.states';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent {

  formSubmitting=false;
  loginForm: FormGroup = this.fb.group({
    username: ['', [Validators.required]],
    password: ['', Validators.compose([Validators.required, Validators.minLength(8)])],
  });

  constructor(private fb: FormBuilder,public adminApi: AdminapiService,private store: Store<AppState>, private toastrService: ToastrService, public router: Router) {}
  ngOnInit() {
  }

  onSubmit(event:any,form: FormGroup) {
    event.preventDefault()
    event.stopPropagation()
    if (form.valid && !this.formSubmitting) {
      this.formSubmitting=true;
      this.adminApi.login(form.value.username,form.value.password).subscribe((data: any) => {
        this.formSubmitting=false;
        if(data.success){
          //this.store.dispatch(new UserInfo())
          this.adminApi.setLoader(true)
          this.adminApi.setSession(data);
          this.router.navigateByUrl('/admin');
          this.adminApi.setLoader(false)
        }else{
					this.toastrService.error(data.message);
        }
      },
      error => {
        this.toastrService.error("unable to handle response");
        this.formSubmitting=false;
      });
    } else {
      this.adminApi.validateAllFields(form);
    }
  }

  get f(): { [key: string]: AbstractControl } {
    return this.loginForm.controls;
  }

}
